import { render, staticRenderFns } from "./menu-group.vue?vue&type=template&id=2ce847d6&scoped=true"
import script from "./menu-group.vue?vue&type=script&lang=js"
export * from "./menu-group.vue?vue&type=script&lang=js"
import style0 from "./menu-group.vue?vue&type=style&index=0&id=2ce847d6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../tmp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce847d6",
  null
  
)

export default component.exports